import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from '@app/core/services/auth.service';
import { LoginPopupService } from '@app/core/services/login-popup.service';
import { AdminAccessDialogComponent } from '@app/shared/admin-access-dialog/admin-access-dialog.component';

export const adminAuthGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const loginPopup = inject(LoginPopupService);
  const dialog = inject(MatDialog);
  const router = inject(Router);

  const session = await authService.ensureAdminSession();
  if (session === 'ok') {
    return true;
  }

  if (session === 'unauthenticated') {
    authService.prepareForSignIn();
    router.navigate(['home']);
    loginPopup.triggerLogin();
    return false;
  }

  dialog.open(AdminAccessDialogComponent);
  return false;
};
